<app-page [simpleTopBar]="globalVars.isMobile()" title="Reacted By">
  <reactions-details></reactions-details>
</app-page>
